export default class extends Controller {
  static targets = ["timeSummaryDisplay"]

  connect() {
    this.update                        = this.update.bind(this);
    this.replaceTimeSummaryDisplayWith = this.replaceTimeSummaryDisplayWith.bind(this);
    App.Helpers.listenToCustomEvent(document, "card-list:activities-update", this.update);
  }

  update(event) {
    const { sourceListID, targetListID } = event.detail;
    if (this.timeDetailsURL && (sourceListID == this.listID || targetListID == this.listID)) {
      App.Helpers.ajaxRequest({ url: this.timeDetailsURL, successHandler: this.replaceTimeSummaryDisplayWith })
    }
  }

  replaceTimeSummaryDisplayWith(response) {
    App.Helpers.replaceElement(this.element, response)
  }

  //
  // GETTERS AND SETTERS
  //

  get listID() {
    return this.data.get("list-id")
  }

  get timeDetailsURL() {
    return this.data.get("time-details-url")
  }
}



// WEBPACK FOOTER //
// ./app/components/templates/assets/javascript/templates-template-time-summary-controller.js